export const getCardImage = (method?: string, brand?: string) => {
  let imageUrl = '/images/card-icons/credit-card.svg';

  switch (method) {
    case 'CREDIT_CARD':
      switch (brand?.toUpperCase()) {
        case 'VISA':
          imageUrl = '/images/card-icons/visa.svg';
          break;
        case 'MASTERCARD':
          imageUrl = '/images/card-icons/mastercard.svg';
          break;
        case 'AMERICAN EXPRESS':
          imageUrl = '/images/card-icons/america_express.svg';
          break;
        case 'AMEX':
          imageUrl = '/images/card-icons/america_express.svg';
          break;
        case 'DISCOVER':
          imageUrl = '/images/card-icons/discover.svg';
          break;
        default:
          break;
      }
      break;
    case 'APPLE_PAY':
      imageUrl = '/images/card-icons/apple.svg';
      break;
    case 'GOOGLE_PAY':
      imageUrl = '/images/card-icons/google_pay.svg';
      break;
    default:
      break;
  }

  return imageUrl;
};
